<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-toolbar text color="white">
          <v-toolbar-title>Dealer Types</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" @click="getDealerTypes">Refresh</v-btn>
              <v-btn color="primary" dark class="mb-2" @click="newDealerType">New Dealer Type</v-btn>
            </template>
            <v-card>
              <app-title>New Dealer Type</app-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-row  v-if="editedItem">
                    <v-col md="6">
                      <v-text-field v-model="editedItem.dealerType" label="Dealer Type"></v-text-field>
                    </v-col>
                    <v-col md="3">
                      <v-text-field v-model="editedItem.minNumServices" label="Min Num Services"></v-text-field>
                    </v-col>

                    <v-col md="3">
                      <v-text-field v-model="editedItem.servicesinPeriod" label="Service in Period"></v-text-field>
                    </v-col>
                    <v-col md="3">
                      <v-text-field v-model="editedItem.overridePercent" label="Override Percent"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-btn v-if="editedItem.id > 0" color="blue darken-1" text @click="remove">Remove</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-data-table :headers="headers" :items="items" class="elevation-1">
          <template v-slot:item="{item,headers}">
            <tr>
              <td :class="`text-xs-${name.align}`" v-for="(name, index) in headers" :key="index">
                <span v-if="name.value.includes('date')">{{item[name.value] | formatDate}}</span>
                <span v-else>{{ item[name.value] }}</span>
              </td>
              <td>
                <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DealerType from "@/models/DealerType";
import { mapActions } from "vuex";
export default {
  name: "DealerTypes",

  data() {
    return {
      dialog: false,
      runType: 1,
      items: [],
      editedItem: {},
      headers: [
        {
          text: "Dealer Type",
          value: "dealerType",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 280
        },
        {
          text: "Min Num Services",
          value: "minNumServices",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Services in Period",
          value: "serviesInPeriod",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Override Percent",
          value: "overridePercent",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        }
      ]
    };
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),

    newDealerType() {
      this.editedItem = new DealerType({ overridePercent: 0 });
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },
    delete() {
      let query = {
        message: `Dealer Type deleted`,
        url: `Commissions/DeleteDealerType/`,
        method: "post",
        body: this.editedItem
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
        })
        .catch(() => {});
    },
    save() {
      let query = {
        message: `Dealer Type added`,
        url: `Commissions/EditDealerType/`,
        method: "post",
        body: [this.editedItem]
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
        })
        .catch(() => {});
    },
    getDealerTypes() {
      let vm = this;
      let query = {
        message: `Runs collected`,
        url: `Commissions/GetDealerTypes`,
        method: "get",
        body: {}
      };
      this.CommissionsRequest(query)
        .then(data => {
          vm.$emit("collected");
          vm.items = data;
        })
        .catch(() => {});
    },
    editItem(val) {
      this.editedItem = Object.assign({}, val);
      this.dialog = true;
    }
  },
  mounted() {
    // this.getDealerTypes();
  }
};
</script>

<style scoped>
</style>